
import CommonNodeLoginForm from './CommonNodeLoginForm';

const EmployeeLoginForm = () => {
    return <CommonNodeLoginForm role={"employee"} loginRoute={"collab-login"} />
}

export default EmployeeLoginForm
























